(() => {
  'use strict';
  const KEY = 'behuli:recently-viewed:v2';
  const LEGACY_KEY = 'behuli_rv';
  const MAX_STORE = 12;
  const MAX_RENDER = 6;
  const TTL = 90 * 24 * 60 * 60 * 1000;
  const currency = window.Shopify?.currency?.active || 'AUD';

  function read() {
    try {
      let items = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!items.length) {
        const legacy = JSON.parse(localStorage.getItem(LEGACY_KEY) || '[]');
        items = Array.isArray(legacy) ? legacy.map((handle) => ({ handle, viewedAt: Date.now() })) : [];
      }
      const cutoff = Date.now() - TTL;
      items = items.filter((item) => item?.handle && (!item.viewedAt || item.viewedAt >= cutoff)).slice(0, MAX_STORE);
      localStorage.setItem(KEY, JSON.stringify(items));
      return items;
    } catch (_) { return []; }
  }

  function save(items) { try { localStorage.setItem(KEY, JSON.stringify(items.slice(0, MAX_STORE))); } catch (_) {} }
  function money(cents) { try { return new Intl.NumberFormat('en-AU', { style: 'currency', currency }).format((Number(cents) || 0) / 100); } catch (_) { return `$${((Number(cents) || 0) / 100).toFixed(2)}`; } }

  const wrapper = document.getElementById('behuli-recently-viewed');
  if (!wrapper) return;
  const current = wrapper.dataset.current;
  if (current) save([{ handle: current, viewedAt: Date.now() }, ...read().filter((item) => item.handle !== current)]);

  async function render() {
    // Fetch extra handles so sold-out pieces can be skipped without leaving the row short.
    const handles = read().map((item) => item.handle).filter((handle) => handle !== current).slice(0, MAX_STORE);
    if (!handles.length) return;
    const inner = document.getElementById('behuli-rv-inner');
    const grid = document.getElementById('behuli-rv-grid');
    const tmpl = document.getElementById('behuli-rv-card-template');
    if (!inner || !grid || !tmpl) return;
    grid.innerHTML = '';
    const root = window.Shopify?.routes?.root || '/';
    const results = await Promise.allSettled(handles.map((handle) => fetch(`${root}products/${handle}.js`).then((response) => { if (!response.ok) throw new Error(); return response.json(); })));
    let shown = 0;
    results.forEach((result) => {
      if (result.status !== 'fulfilled') return;
      const p = result.value;
      if (!p.available || shown >= MAX_RENDER) return;
      const node = tmpl.content.cloneNode(true);
      const a = node.querySelector('a');
      const img = node.querySelector('img');
      const name = node.querySelector('.behuli-rv__name');
      const price = node.querySelector('.behuli-rv__price');
      a.href = `${root}products/${p.handle}`;
      if (p.featured_image) { img.src = p.featured_image; img.alt = p.title; } else img.remove();
      name.textContent = p.title;
      price.textContent = money(p.price_min || p.price);
      grid.appendChild(node);
      shown += 1;
    });
    if (grid.children.length) inner.style.display = '';
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render); else render();
})();
